<template>
    <Spinner v-if="displaySpinner" />
    <Fluid class="field">
        <label for="name">Name</label>
        <InputText
            id="name"
            autofocus
            v-model="newName"
            required
            :value="newName"
        />
    </Fluid>
    <div class="buttons">
        <Button label="Cancel" text severity="secondary" @click="cancel" />
        <Button label="Save" severity="primary" @click="closeAndSave" />
    </div>
</template>

<script setup lang="ts">
import { Ref, computed, inject, ref } from "vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import Spinner from "@/shared/Spinner.vue";
import { useDomainsManager, useDomainsStore } from "@/stores/domains-store";
import { useHotKeys } from "@/composables/hotkeys";
import InputText from "primevue/inputtext";

const newName = ref("");
const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");

const { create } = useDomainsStore();
const { isLoading } = useDomainsManager();
const { addHotKey } = useHotKeys();

const cancel = () => dialogRef?.value.close();
const closeAndSave = async () => {
    await create(newName.value);
    dialogRef?.value?.close();
};

const displaySpinner = computed(() => {
    return isLoading.value;
});

/**
 * Save on cmd/ctrl + enter.
 */
addHotKey("CommandOrMeta+Enter", async () => {
    await closeAndSave();
});
</script>

<style lang="scss" scoped>
.field {
    padding-bottom: 1em;

    label {
        display: block;
        margin-bottom: 0.5em;
    }
}

.buttons {
    display: flex;
    justify-content: end;
    margin-top: 1em;
}
</style>
